// extracted by mini-css-extract-plugin
export var footerStateNav = "stateNav-module--footerStateNav--3bb80";